
function modal() {
  console.log('Modal script loaded');

  // Obsługa wszystkich modali na stronie
  function initializeModals() {
    // Obsługa wszystkich inquiryModal (może być wiele na stronie)
    const inquiryModals = document.querySelectorAll('.custom-modal');
    console.log('Znaleziono modali:', inquiryModals.length);
    inquiryModals.forEach((modal, index) => {
      console.log(`Inicjalizuję modal ${index + 1}:`, modal);
      initializeInquiryModal(modal);
    });

    // Obsługa googleMapModal
    const googleMapModal = document.getElementById('googleMapModal');
    if (googleMapModal) {
      initializeGoogleMapModal(googleMapModal);
    }

    // Obsługa standardowych modali z klasą .modal
    const standardModals = document.querySelectorAll('.modal');
    standardModals.forEach(modal => {
      initializeStandardModal(modal);
    });
  }

  // Inicjalizacja inquiry modal
  function initializeInquiryModal(modal) {
    const modalId = modal.id || 'inquiryModal';
    const closeBtn = modal.querySelector('.custom-modal-close');
    const closeBtnFooter = modal.querySelector('.custom-modal-btn-close');
    const overlay = modal.querySelector('.custom-modal-overlay');

    // Znajdź wszystkie przyciski które otwierają ten modal
    const openBtns = document.querySelectorAll(`[data-target="#${modalId}"]`);

    console.log(`Znaleziono ${openBtns.length} przycisków dla modala #${modalId}`);

    // Dodaj event listener dla każdego przycisku otwierającego
    openBtns.forEach((openBtn, index) => {
      console.log(`Dodaję event listener dla przycisku ${index + 1}:`, openBtn);
      openBtn.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Kliknięto przycisk, otwieranie modala');
        console.log('Modal przed otwarciem:', modal.style.display);
        modal.style.display = 'block';
        console.log('Modal po otwarciu:', modal.style.display);
        console.log('Computed style:', window.getComputedStyle(modal).display);
        document.body.style.overflow = 'hidden';
      });
    });

    if (openBtns.length === 0) {
      console.warn('Nie znaleziono przycisków dla modala:', modal);
    }

    // Zamknij modal - przycisk X
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        closeInquiryModal(modal);
      });
    }

    // Zamknij modal - przycisk Zamknij
    if (closeBtnFooter) {
      closeBtnFooter.addEventListener('click', function() {
        closeInquiryModal(modal);
      });
    }

    // Zamknij modal - kliknięcie w tło
    if (overlay) {
      overlay.addEventListener('click', function() {
        closeInquiryModal(modal);
      });
    }

    // Zamknij modal - klawisz ESC (dodaj event listener tylko raz na modal)
    const escHandler = function(e) {
      if (e.key === 'Escape' && modal.style.display === 'block') {
        closeInquiryModal(modal);
      }
    };

    // Usuń poprzedni handler jeśli istnieje
    if (modal.escHandler) {
      document.removeEventListener('keydown', modal.escHandler);
    }

    // Zapisz handler w elemencie modala i dodaj nowy
    modal.escHandler = escHandler;
    document.addEventListener('keydown', escHandler);
  }

  // Zamknij inquiry modal
  function closeInquiryModal(modal) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  // Inicjalizacja Google Map modal
  function initializeGoogleMapModal(modal) {
    const openBtns = document.querySelectorAll('.google-map-show');
    const closeBtn = modal.querySelector('.close');

    openBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        closeGoogleMapModal(modal);
      });
    }

    // Zamknij modal - kliknięcie w tło
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        closeGoogleMapModal(modal);
      }
    });

    // Zamknij modal - klawisz ESC
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.style.display === 'block') {
        closeGoogleMapModal(modal);
      }
    });
  }

  // Zamknij Google Map modal
  function closeGoogleMapModal(modal) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  // Inicjalizacja standardowych modali
  function initializeStandardModal(modal) {
    const modalClose = modal.querySelector('.modal-close');

    if (!modalClose) {
      console.warn('Modal close button not found for modal:', modal);
      return;
    }

    modalClose.addEventListener('click', function() {
      modal.classList.remove('is-active');
    });

    window.addEventListener('click', function(event) {
      if (event.target === modal) {
        modal.classList.remove('is-active');
      }
    });
  }

  // Inicjalizuj wszystkie modale po załadowaniu DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeModals);
  } else {
    initializeModals();
  }
}

modal();